window._ = require("lodash");
//TODO: Eliminar si no es encuentran errores de bootstrap y jquery
// import $ from "jquery"; //Este import funcionaba (mas o menos xd)
// import jQuery from 'jquery'; //Este import funcionaba (mas o menos xd)
// import * as bootstrap from 'bootstrap'; //Este import funcionaba :v
import intersect from "@alpinejs/intersect";
import Alpine from "alpinejs";

import ApexCharts from "apexcharts";
import Swal from "sweetalert2";

window.ApexCharts = ApexCharts;
window.Swal = Swal;

//TODO: Eliminar si no es encuentran errores de bootstrap y jquery
// window.$ = $; //Este import funcionaba (mas o menos xd)
// window.jQuery = jQuery; //Este import funcionaba (mas o menos xd)
// try {
//     window.bootstrap = bootstrap; //Este import funcionaba
//
// } catch (e) {
//     console.log('Error loading bootstrap:', e);
// }

try {
    window.$ = window.jQuery = require("jquery");
    window.Popper = require("@popperjs/core");
    window.bootstrap = require("bootstrap");
} catch (e) {
    console.log("Error loading jquery or/and bootstrap:", e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// // window.bootstrap = bootstrap;
// window.bootstrap = require("bootstrap");

window.Alpine = Alpine;
Alpine.plugin(intersect);
// Alpine.start() is called in app.js after all plugins are loaded

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
